import React, { useState } from 'react';
import { useContractState } from '../../context/ContractContext';
import { formatUSDT, bpToPct } from '../../utils/format';
import LevelMembers from './LevelMembers';

// L1..L15 percentages (basis points) mirror contract defaults
const LEVEL_BP = [300,200,100,50,50,50,50,25,25,25,25,25,25,25,25];

function Chev() {
  return (
    <span className="chev">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </span>
  );
}

export default function LevelBreakdown() {
  const { levelCounts = [], levelVolumes = [], levelEligibility = [] } = useContractState();
  const [openLevel, setOpenLevel] = useState(-1); // only one open at a time keeps things light

  function toggle(i) {
    setOpenLevel(prev => (prev === i ? -1 : i));
  }

  return (
    <div>
      {LEVEL_BP.map((bp, i) => {
        const count = levelCounts[i] || 0;
        const vol = levelVolumes[i] || 0;
        const eligible = levelEligibility[i] === true;
        const open = openLevel === i;
        return (
          <div key={i} className={`level-item ${open ? 'open' : ''}`}>
            <div
              className="level-row"
              onClick={() => toggle(i)}
              role="button"
              aria-expanded={open}
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(i); } }}
            >
              <div className="left">
                <div className={`num ${eligible ? '' : 'locked'}`}>L{i + 1}</div>
                <div>
                  <div className="k">{count} member{count === 1 ? '' : 's'}</div>
                  <div className="sub">{eligible ? 'Qualified' : 'Not qualified'}</div>
                </div>
              </div>
              <div className="row" style={{ gap: 10 }}>
                <div className="right">
                  <div className="pct">{bpToPct(bp)}</div>
                  <div className="vol">Vol {formatUSDT(vol, { decimals: 0 })}</div>
                </div>
                <Chev />
              </div>
            </div>
            {open && <LevelMembers level={i} />}
          </div>
        );
      })}
    </div>
  );
}
